import {Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';

@Component({
  selector: 'app-assistant-profile-picture',
  templateUrl: './assistant-profile-picture.component.html',
  styleUrls: ['./assistant-profile-picture.component.scss']
})
export class AssistantProfilePictureComponent implements OnInit, OnChanges {

  @Input() image: string;
  @Input() size: 'small' | 'medium' | 'large' = 'large';

  @ViewChild('container', {static: true}) container: ElementRef<HTMLDivElement>;


  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.size) {
      this.size = changes.size.currentValue;
    }
    this.container.nativeElement.style.setProperty('--size', this.computeSize());
    this.container.nativeElement.style.setProperty('--radius', this.computeRadius());
  }

  computeSize() {
    switch (this.size) {
      case 'small':
        return '32px';
      case 'medium':
        return '64px';
      case 'large':
        return '100px';
    }
  }

  computeRadius() {
    switch (this.size) {
      case 'small':
        return '5px';
      case 'medium':
        return '10px';
      case 'large':
        return '20px';
    }
  }

}
